/* eslint-disable camelcase */
const api = {
  auth: {
    login: '/admin/login',
  },
  omre: {
    base: '/',
  },
  lottery: {
    base: '/admin/team/lottery',
    test: '/lottery',
    main: '/admin/lottery',
    excel: '/admin/lottery/excel',
  },
  message: {
    base: '/admin/team/message',
  },
  report: {
    base: '/admin/team/message',
  },
  log: {
    base: '/admin/log',
  },
  settings: {
    base: '/admin/setting',
  },
  excel:{
    base :(id) => `/admin/travel_registers/${id}/export_report`
  },
  notification: {
    base: '/admin/notification',
    client:`/admin/notification/clients`,
    send_again:`/admin/notification/send_again`,
  },
  chart:{
    base : `/admin/chart`
  },
  caravan: {
    base: '/admin/team',
    agent: '/admin/team/agent',
    client: '/admin/team/client',
    clientWithCodeMelli: '/admin/team/client_melli',
    social: '/admin/team/social',
    message: '/admin/team/message',
    bank: '/admin/team/bank',
    input: '/admin/team/input',
    excel:(travel_id) => `/admin/export-teams/${travel_id}`,
    hajExcel:(team_id) => `/admin/export-haj/${team_id}`,
    hajJson: `/admin/export-haj-json`,
    groupSendToHaj: (team_id) => `/admin/change_status/team`,
    excelCaravanClients:(travel_id) => `/admin/export-teams-clients/${travel_id}`,
    zipCaravanClientsImage:`/admin/export-teams-images`
  },
  admin: {
    base: '/admin',
    team : '/admin/team/admin'
  },
  role: {
    base: '/admin/role',
  },
  permission: {
    base: '/admin/permission',
  },
  agent: {
    base: '/admin/agent',
  },
  changeStatus: {
    base: '/admin/change_status',
  },
  agentRole: {
    base: '/admin/agent',
  },
  university: {
    base: '/admin/university',
    uploadExcel : '/admin/university_excel'
  },
  universityCategory: {
    base: '/admin/university_category',
  },
  travel: {
    base: '/admin/travel',
    list: '/admin/travel/list',
    chart: '/admin/travel/chart',
  },
  
  bank: {
    base: '/admin/team/bank',
  },

  travelHistory: { base: '/admin/travel/history' },
  travelRegister: {
    base: '/admin/travel_register',
    register: { base: '/admin/register' },
    excel : (id) =>  `/admin/travel_registers/${id}/export`,
    streamExcel :`/admin/export-excel-stream`,
    universityExcel :`/admin/get_excel`,
  },
  form: {
    base: '/admin/form',
    input: '/admin/form/input',
    sample: '/admin/form/sample',
    sampleForm: '/admin/sample/form',
    sectionInput: '/admin/form/section_input',
  },

  createFormBySample: {
    base: '/admin/create_form_by_sample',
  },

  dispatchDate: {
    base: '/admin/dispatch',
  },
  social: {
    base: '/admin/social',
  },
  section: {
    base: '/admin/form/section',
  },
  // section: {
  //   base: '/admin/form/section',
  // },
  input: {
    base: '/admin/form/input',
  },
  public: {
    form: {
      base: '/public/form',
    },
    section: {
      base: '/public/form/section',
    },
    input: {
      base: '/public/form/input',
    },
    travel: {
      base: '/public/travel',
    },
    travelRegister: {
      base: '/admin/travel_register',
    },
  },
  client: {
    base: '/admin/client',
    register: '/admin/client/register',
    word : "/client/word"
  },
  // client: {
  //   travel: {
  //     base: '/client/travel',
  //   },
  //   auth: {
  //     login: '/client/login',
  //     verify: '/client/verify_code',
  //   },
  // },
  province: {
    base: '/public/province',
    admin: '/admin/province',
    byId: '/province',
  },
  city: {
    base: '/public/city',
    byId: '/city',
  },
};

export default api;
